import { useEffect, useMemo, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import Text from '@components/Text';
import SurveyJsPollRuntime from '@shared/Resources/Poll/Client/SurveyJsPollRuntime';
import { useTranslation } from 'react-i18next';
// import { buildVideoElement } from './videoElementUtils';
import {
  EditorWrapper,
  EditorContent,
  EditorGrid,
  JsonInput,
  PreviewPanel,
  ErrorText,
  // TemplatesRow,
  // TemplateButton,
  LinkTag,
} from './styles';

const isSchemaValid = (parsed) => parsed && Array.isArray(parsed.pages);

const getDefaultSurveySchema = (title) => ({
  title,
  pages: [{ name: 'page1', elements: [] }],
});

const buildSignatureElement = (suffix) => ({
  type: 'signaturepad',
  name: `user_signature_${suffix}`,
  title: 'Please sign below',
  isRequired: true,
});

const SurveyJsPollEditor = ({ schema, onSchemaChange, defaultTitle }) => {
  const { t } = useTranslation();
  const isLocalUpdateRef = useRef(false);
  const surveySchema = useMemo(
    () => schema || getDefaultSurveySchema(defaultTitle),
    [schema, defaultTitle],
  );
  const [jsonValue, setJsonValue] = useState(JSON.stringify(surveySchema, null, 2));
  const [jsonError, setJsonError] = useState('');

  // const appendElementToSchema = (elementFactory) => {
  //   const nextSchema = JSON.parse(JSON.stringify(surveySchema));

  //   if (!Array.isArray(nextSchema.pages) || nextSchema.pages.length === 0) {
  //     nextSchema.pages = [{ name: 'page1', elements: [] }];
  //   }

  //   const firstPage = nextSchema.pages[0];
  //   if (!Array.isArray(firstPage.elements)) {
  //     firstPage.elements = [];
  //   }

  //   const suffix = Date.now();
  //   firstPage.elements.push(elementFactory(suffix));

  //   const formattedTemplate = JSON.stringify(nextSchema, null, 2);
  //   setJsonValue(formattedTemplate);
  //   setJsonError('');
  //   isLocalUpdateRef.current = true;
  //   onSchemaChange(nextSchema);
  // };

  // const addVideoElement = () => {
  //   const videoUrl = window.prompt(
  //     t('PollBuilder.videoUrlPrompt'),
  //     'https://www.youtube.com/embed/dQw4w9WgXcQ'
  //   );
  //   if (!videoUrl) {
  //     return;
  //   }

  //   appendElementToSchema((suffix) => buildVideoElement(videoUrl, suffix));
  // };

  // const addSignatureElement = () => {
  //   appendElementToSchema((suffix) => buildSignatureElement(suffix));
  // };

  const onJsonChange = (event) => {
    const nextValue = event.target.value;
    setJsonValue(nextValue);

    try {
      const parsed = JSON.parse(nextValue);
      if (!isSchemaValid(parsed)) {
        setJsonError(t('PollBuilder.schemaPagesRequired'));
        isLocalUpdateRef.current = true;
        onSchemaChange(null);
        return;
      }
      setJsonError('');
      isLocalUpdateRef.current = true;
      onSchemaChange(parsed);
    } catch (e) {
      setJsonError(t('PollBuilder.invalidJsonSyntax'));
      isLocalUpdateRef.current = true;
      onSchemaChange(null);
    }
  };

  useEffect(() => {
    if (isLocalUpdateRef.current) {
      isLocalUpdateRef.current = false;
      return;
    }
    const nextSchema = schema || getDefaultSurveySchema(defaultTitle);
    setJsonValue(JSON.stringify(nextSchema, null, 2));
    setJsonError('');
  }, [schema, defaultTitle]);

  return (
    <EditorWrapper>
      <EditorContent>
        <LinkTag href="https://surveyjs.io/create-free-survey" target="_blank" rel="noopener noreferrer">
          {t('PollBuilder.description')}
        </LinkTag>
        {/* <Text size="H4" weight="900">
          {t('PollBuilder.title')}
        </Text> */}
        {/* <TemplatesRow>
          <TemplateButton type='button' onClick={addVideoElement}>
            {t('PollBuilder.templateMediaQuestion')}
          </TemplateButton>
          <TemplateButton type='button' onClick={addSignatureElement}>
            {t('PollBuilder.templateSignature')}
          </TemplateButton>
        </TemplatesRow> */}
        {/* <Text size='T4' textColor='DISABLED' style={{ display: 'block', marginTop: 8 }}>
          {t('PollBuilder.templateHint')}
        </Text> */}
      </EditorContent>

      <EditorGrid>
        <div>
          <Text size='T3' weight='900'>{t('PollBuilder.jsonInput')}</Text>
          <JsonInput
            value={jsonValue}
            onChange={onJsonChange}
            spellCheck={false}
            hasError={Boolean(jsonError) ? 1 : 0}
          />
          {jsonError ? <ErrorText>{jsonError}</ErrorText> : null}
        </div>

        <div>
          <Text size='T3' weight='900'>{t('PollBuilder.preview')}</Text>
          <PreviewPanel>
            {!jsonError ? (
              <SurveyJsPollRuntime schema={surveySchema} readOnly={false} />
            ) : (
              <Text size='T4' textColor='DISABLED'>{t('PollBuilder.previewUnavailable')}</Text>
            )}
          </PreviewPanel>
        </div>
      </EditorGrid>
    </EditorWrapper>
  );
};

SurveyJsPollEditor.propTypes = {
  schema: PropTypes.object,
  onSchemaChange: PropTypes.func.isRequired,
  defaultTitle: PropTypes.string,
};

SurveyJsPollEditor.defaultProps = {
  defaultTitle: 'New Poll',
};

export default SurveyJsPollEditor;
